@if ((icon$ | async); as icon) {
  <fa-icon
    [animation]="animation()"
    [icon]="icon"
    [rotate]="rotate()"
    [title]="title() || ''"
  ></fa-icon>
}
